module.exports = __webpack_public_path__ + "img/sb_4@2x.78a64337.png";